import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'
import imagen_1 from '@/assets/img_1.png'
import imagen_2 from '@/assets/img_2.png'
import imagen_3 from '@/assets/img_3.png'
import imagen_4 from '@/assets/img_4.png'
import imagen_5 from '@/assets/img_5.png'
import imagen_6 from '@/assets/img_6.png'
import imagen_7 from '@/assets/img_7.png'
import imagen_8 from '@/assets/img_8.png'
import imagen_9 from '@/assets/img_9.png'
import imagen_10 from '@/assets/img_10.png'
import imagen_11 from '@/assets/img_11.png'
import imagen_12 from '@/assets/img_12.png'
import imagen_13 from '@/assets/img_13.png'
import imagen_14 from '@/assets/img_14.png'
import imagen_15 from '@/assets/img_15.png'
import imagen_16 from '@/assets/img_16.png'
import imagen_17 from '@/assets/img_17.png'
import imagen_18 from '@/assets/img_18.png'
import imagen_19 from '@/assets/img_19.png'
import imagen_20 from '@/assets/img_20.png'
import imagen_21 from '@/assets/img_21.png'

function getBase64FromImage(imgUrl) {
    return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            resolve(canvas.toDataURL('image/png'))
        }
        img.src = imgUrl
    })
}
function generarBody(opcionesTabla, respuestas) {
    return opcionesTabla.map(op => {
        let seleccion = respuestas.find(r => r.descripcion === op[0])

        if (seleccion) {
            return [
                {
                    content: op[0],
                    styles: {
                        fillColor: [200, 255, 200] // verde claro
                    }
                },
                {
                    content: op[1],
                    styles: {
                        fillColor: [200, 255, 200],
                        fontStyle: 'bold'
                    }
                }
            ]
        }

        return op
    })
}
function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
    return palabras.toUpperCase()
}

function returnSi(value) {
    if (value == 'Sí') {
        return "X"
    } else {
        return ""
    }
}

function returnNo(value) {
    if (value == 'No') {
        return "X"
    } else {
        return ""
    }
}

function returnBool(value) {
    if (value == true) {
        return "X"
    } else {
        return ""
    }
}
function returnBoolFALSE(value) {
    if (value == false) {
        return "X"
    } else {
        return ""
    }
}


function formatearFechaHora(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(fecha))
}

function condicionI1(valor){
    if(valor =='rbInicialIndependiente'){
        return 'X'
    }else{
        return ''
    }
}
function condicionI2(valor){
    if(valor =='rbInicialSilla'){
        return 'X'
    }else{
        return ''
    }
}
function condicionI3(valor){
    if(valor =='rbInicialAyudas'){
        return 'X'
    }else{
        return ''
    }
}
function condicionI4(valor){
    if(valor =='rbInicialCamilla'){
        return 'X'
    }else{
        return ''
    }
}

function condicionF1(valor){
    if(valor =='rbFinalIndependiente'){
        return 'X'
    }else{
        return ''
    }
}

function condicionF2(valor){
    if(valor =='rbFinalSilla'){
        return 'X'
    }else{
        return ''
    }
}
function condicionF3(valor){
    if(valor =='rbFinalAyudas'){
        return 'X'
    }else{
        return ''
    }
}
function condicionF4(valor){
    if(valor =='rbFinalCamilla'){
        return 'X'
    }else{
        return ''
    }
}

function campoLinea(doc, label, valor, x, y, anchoLinea = 70) {

    // Label
    doc.text(label, x, y)

    // Valor
    doc.setFont("helvetica", "normal")
    doc.text(valor || "-", x + 30, y)

    // Línea punteada
    doc.setDrawColor(100)
    doc.setLineDash([1, 1])
    doc.line(x + 28, y + 1, x + anchoLinea, y + 1)

    doc.setLineDash([])

    doc.setFont("helvetica", "bold")
}

function gradoL(value) {
    if (value == 'L') {
        return 'X'
    } else {
        return ''
    }
}

function gradoM(value) {
    if (value == 'M') {
        return 'X'
    } else {
        return ''
    }
}

function gradoS(value) {
    if (value == 'S') {
        return 'X'
    } else {
        return ''
    }
}
function campo(doc, label, value, x, y, width, minHeight = 10) {
    const text = value || ''
    const textLines = doc.splitTextToSize(text, width - 2)
    const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

    const pageHeight = doc.internal.pageSize.height
    const marginBottom = 25

    if (y + boxHeight + marginBottom > pageHeight) {
        doc.addPage()
        y = 20
    }

    // Label
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0, 0, 0)
    doc.text(label, x, y)

    // Texto
    doc.setFontSize(8)
    doc.setTextColor(78, 78, 78)
    doc.setFont('helvetica', 'normal')


    // Caja gris
    doc.setFillColor(245, 245, 245)
    doc.rect(x, y + 1, width, boxHeight, 'F')

    // Texto
    doc.text(textLines, x + 2, y + 5)
    doc.setDrawColor(208, 208, 208)
    doc.setLineWidth(0.3)
    doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

    return y + boxHeight + 6
}

function tituloSeccion(doc, texto, y) {
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)
    doc.text(texto.toUpperCase(), 15, y)

    doc.setDrawColor(7, 88, 144)
    doc.setLineWidth(0.4)
    doc.line(15, y + 2, 200, y + 2)

    return y + 8
}

async function generarHojaFisioterapia(consulta, cita, medico, noExpediente) {
    const doc = new jsPDF('p', 'mm', 'letter')
    const pageWidth = doc.internal.pageSize.getWidth()

    const logo1 = await getBase64FromImage(logoIzquierdo)
    const logo2 = await getBase64FromImage(logoDerecho)

    console.log(consulta)
    console.log(cita)
    console.log(medico)

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    let y = 38

    // DATOS DEL PACIENTE
    autoTable(doc, {
        startY: y,
        head: [
            [
                {
                    content: "Datos del Paciente",
                    colSpan: 2,
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

        body: [
            ["Nombre: " + consulta.datosPaciente.nombrePaciente, "Sexo: " + consulta.datosPaciente.sexo],
            ["Domicilio: " + consulta.datosPaciente.domicilio, "Edad: " + consulta.datosPaciente.edad],
            ["Teléfono: " + + consulta.datosPaciente.telefono, "E. Civil: " + consulta.datosPaciente.estadoCivil],
            ["Ocupación: " + consulta.datosPaciente.ocupacion, "Escolaridad: " + consulta.datosPaciente.escolaridad]
        ],
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        margin: {
            left: 15   // margen izquierdo
        },

        tableWidth: 110,
    })

    // DATOS DEL MEDICO
    autoTable(doc, {
        startY: y,
        margin: {
            left: 130   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        tableWidth: 70,
        head: [
            [
                {
                    content: "Fisioterapeuta",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [medico.nombre + ' ' + medico.apellidoPaterno + ' ' + medico.apellidoMaterno],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    y = doc.lastAutoTable.finalY += 3;

    // EXPEDIENTE
    autoTable(doc, {
        startY: y,
        margin: {
            left: 130   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        tableWidth: 32.5,
        head: [
            [
                {
                    content: "No. Expediente",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [noExpediente],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    // FECHA
    autoTable(doc, {
        startY: y,
        margin: {
            left: 167.5   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        tableWidth: 32.5,
        head: [
            [
                {
                    content: "Fecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [formatearFecha(cita.fechaCita)],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    y = doc.lastAutoTable.finalY += 5;

    // EXPLORACION FISICA
    autoTable(doc, {
        startY: y,
        margin: { left: 15 },
        tableWidth: 60,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Exploración Fsica",
                    colSpan: 2,
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            ["Peso:", consulta.exploracionFisica.peso],
            ["Talla", consulta.exploracionFisica.talla],
            ["Estatura:", consulta.exploracionFisica.estatura],
            ["(IMC):", consulta.exploracionFisica.imc],
            ["Etnia:", consulta.exploracionFisica.etnia]
        ],
        columnStyles: {
            0: { halign: "left", cellWidth: 15 },
            1: { halign: "center" },
        },
    })

    // MOTIVOS DE LA CONSULTA
    autoTable(doc, {
        startY: y,
        margin: { left: 80 },
        tableWidth: 58,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [
                {
                    content: "Motivo de la consulta",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.motivoConsulta],
        ],
    })

    //  TRATAMIENTOS PREVIOS
    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [
                {
                    content: "Tratamientos Previos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.tratamientoPrevio],
        ],
    })

    y = doc.lastAutoTable.finalY += 25;


    // ANTECEDENTES PATOLOGICOS Y HEREDOFAMILIARES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Antecedentes Patológicas y Heredofamiliares",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY += 2.5;

    autoTable(doc, {

        startY: y,
        margin: { left: 15 },
        tableWidth: 60,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0],
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },

        head: [
            [{
                content: "",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 9,
                    cellPadding: 0
                },
            },
            {
                content: "Si",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "No",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "Especifique",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            }
            ]
        ],
        body: [
            ["Diabetes", returnSi(consulta.antecedentesPatologicos.diabetes.valor), returnNo(consulta.antecedentesPatologicos.diabetes.valor), consulta.antecedentesPatologicos.diabetes.espesificacion],
            ["Alergia", returnSi(consulta.antecedentesPatologicos.alergia.valor), returnNo(consulta.antecedentesPatologicos.alergia.valor), consulta.antecedentesPatologicos.alergia.espesificacion],
            ["HTA", "", returnSi(consulta.antecedentesPatologicos.hta.valor), returnNo(consulta.antecedentesPatologicos.hta.valor), consulta.antecedentesPatologicos.hta.espesificacion],
            ["Cáncer", returnSi(consulta.antecedentesPatologicos.cancer.valor), returnNo(consulta.antecedentesPatologicos.cancer.valor), consulta.antecedentesPatologicos.cancer.espesificacion],
            ["Transfusiones", returnSi(consulta.antecedentesPatologicos.transfusiones.valor), returnNo(consulta.antecedentesPatologicos.transfusiones.valor), consulta.antecedentesPatologicos.transfusiones.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 17 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
        },
    })

    autoTable(doc, {
        startY: y,
        margin: { left: 80 },
        tableWidth: 58,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 9,
                    cellPadding: 0
                },
            },
            {
                content: "Si",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "No",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "Especifique",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            }
            ]
        ],
        body: [
            ["Enf. Reumáticas", returnSi(consulta.antecedentesPatologicos.enfReumaticas.valor), returnNo(consulta.antecedentesPatologicos.enfReumaticas.valor), consulta.antecedentesPatologicos.enfReumaticas.espesificacion],
            ["Encames", returnSi(consulta.antecedentesPatologicos.encames.valor), returnNo(consulta.antecedentesPatologicos.encames.valor), consulta.antecedentesPatologicos.encames.espesificacion],
            ["Accidentes", returnSi(consulta.antecedentesPatologicos.accidentes.valor), returnNo(consulta.antecedentesPatologicos.accidentes.valor), consulta.antecedentesPatologicos.accidentes.espesificacion],
            ["Cardiopatías", returnSi(consulta.antecedentesPatologicos.cardiopatias.valor), returnNo(consulta.antecedentesPatologicos.cardiopatias.valor), consulta.antecedentesPatologicos.cardiopatias.espesificacion],
            ["Cirugías", returnSi(consulta.antecedentesPatologicos.cirugias.valor), returnNo(consulta.antecedentesPatologicos.cirugias.valor), consulta.antecedentesPatologicos.cirugias.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 20 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
        },
    })

    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7,
                    cellPadding: 0
                },
            },
            {
                content: "Si",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "No",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "Especifique",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            }
            ]
        ],
        body: [
            ["Fracturas", returnSi(consulta.antecedentesPatologicos.fracturas.valor), returnNo(consulta.antecedentesPatologicos.fracturas.valor), consulta.antecedentesPatologicos.fracturas.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 17 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
        },
    })

    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "Signos Vitales",
                colSpan: 4,
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7,
                    cellPadding: 1
                },
            },
            ]
        ],
        body: [
            ["T/A: " + consulta.antecedentesPatologicos.sistolica + ' ' + consulta.antecedentesPatologicos.distolica, "TEMP: " + consulta.antecedentesPatologicos.temperatura, "FC: " + consulta.antecedentesPatologicos.frecuenciaCardiaca, "FR: " + consulta.antecedentesPatologicos.frecuenciaRespiratoria],
        ],
    })

    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "Espasmos o Contractura Muscular",
                colSpan: 4,
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7,
                    cellPadding: 1
                },
            },
            ]
        ],
        body: [
            ["Si: " + returnSi(consulta.antecedentesPatologicos.espasmosContractura.value), "No: " + returnNo(consulta.antecedentesPatologicos.espasmosContractura.value), "Sitio/Caracteristicas: " + consulta.antecedentesPatologicos.espasmosContractura.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 5, halign: "center" }, // si
            1: { cellWidth: 5, halign: "center" }, // no
        },
    })

    // HABITOS DE SALUD
    y = doc.lastAutoTable.finalY += 5;
    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 123,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Hábitos de Salud",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    autoTable(doc, {
        startY: y,
        margin: { left: 143, },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Mujeres: Estado de Ingravidez",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    y = doc.lastAutoTable.finalY += 2.5;

    autoTable(doc, {

        startY: y,
        margin: { left: 15 },
        tableWidth: 60,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0],
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },

        head: [
            [{
                content: "",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 9,
                    cellPadding: 0
                },
            },
            {
                content: "Si",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "No",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "Especifique",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            }
            ]
        ],
        body: [
            ["Tabaquismo", returnSi(consulta.habitosSalud.tabaquismo.valor), returnNo(consulta.habitosSalud.tabaquismo.valor), consulta.habitosSalud.tabaquismo.espesificacion],
            ["Alcoholismo", returnSi(consulta.habitosSalud.alcoholismo.valor), returnNo(consulta.habitosSalud.alcoholismo.valor), consulta.habitosSalud.alcoholismo.espesificacion],
            ["Drogas", returnSi(consulta.habitosSalud.drogas.valor), returnNo(consulta.habitosSalud.drogas.valor), consulta.habitosSalud.drogas.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 17 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
        },
    })

    // ESTADO DE INGRAVIDEZ
    autoTable(doc, {
        startY: y,
        margin: { left: 80 },
        tableWidth: 58,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 9,
                    cellPadding: 0
                },
            },
            {
                content: "Si",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "No",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            },
            {
                content: "Especifique",
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7
                }
            }
            ]
        ],
        body: [
            ["Act. Física", returnSi(consulta.habitosSalud.actividadFisica.valor), returnNo(consulta.habitosSalud.actividadFisica.valor), consulta.habitosSalud.actividadFisica.espesificacion],
            ["Se automedica", returnSi(consulta.habitosSalud.autoMedica.valor), returnNo(consulta.habitosSalud.autoMedica.valor), consulta.habitosSalud.autoMedica.espesificacion],
            ["Pasatiempo", returnSi(consulta.habitosSalud.pasatiempo.valor), returnNo(consulta.habitosSalud.pasatiempo.valor), consulta.habitosSalud.pasatiempo.espesificacion],
        ],
        columnStyles: {
            0: { cellWidth: 20 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
        },
    })

    // EMBARAZO
    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "Embarazada",
                colSpan: 4,
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 7,
                    cellPadding: 1
                },
            },
            ]
        ],
        body: [
            ["Si: " + returnSi(consulta.embarazada.valor), "No: " + returnNo(consulta.embarazada.valor), "Especifique: " + consulta.embarazada.valor],
        ],
        columnStyles: {
            0: { cellWidth: 5, halign: "center" }, // si
            1: { cellWidth: 5, halign: "center" }, // no
        },
    })

    // NUMERO DE HIJOS
    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 143 },
        tableWidth: 57,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1,
        },
        head: [
            [{
                content: "Cuantos hijos tiene:",
                colSpan: 3,
                styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 6,
                    cellPadding: 1
                },
            },
            ]
        ],
        body: [
            [consulta.nHijos],
        ],

    })

    // Diagnóstico Médico en Rehabilitación
    y = doc.lastAutoTable.finalY += 5;
    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Diagnóstico Médico en Rehabilitación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Reflejos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Sensibilidad",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Lenguaje/Horientación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Otros",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: [
            [consulta.diagnosticoMMedicoRehabilitacion.reflejos, consulta.diagnosticoMMedicoRehabilitacion.sensibilidad, consulta.diagnosticoMMedicoRehabilitacion.lenguaje, consulta.diagnosticoMMedicoRehabilitacion.otros],
        ],
    })

    let cicatrices = []
    for (let a in consulta.cicatricesQuirurgicas) {
        let palabra = "Sitio - " + returnBool(a.sitio) + " Queloide - " + returnBool(a.queloide) + " Retractil - " + returnBool(a.retractil) + " Abierta - " + returnBool(a.abierta) + " Con Adherencia - " + returnBool(a.adherencia) + " Hipertrófica - " + returnBool(a.hipertrofica)

        cicatrices.push(palabra)
    }

    // CICATRIZ QUIRURGICA
    autoTable(doc, {
        startY: y - 5.5,
        margin: { left: 110, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Cicatríz Quirúrgica",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            cicatrices
        ],
    })

    // TRASLADOS
    let y2 = doc.lastAutoTable.finalY + 5;

    y = doc.lastAutoTable.finalY += 5;

    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Traslados",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    // TRASLADOS
    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Val. Inicial",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Independiente",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Silla de Ruedas",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Ayuda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Camilla",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: [
            ["", condicionI1(consulta.valInicialTraslado), condicionI2(consulta.valInicialTraslado), condicionI3(consulta.valInicialTraslado), condicionI4(consulta.valInicialTraslado)],
        ],
    })

    y = doc.lastAutoTable.finalY;
    autoTable(doc, {
        startY: y,
        margin: { left: 15, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Val. Final",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Independiente",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Silla de Ruedas",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Ayuda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Camilla",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: [
            ["", condicionF1(consulta.valInicialTraslado), condicionF2(consulta.valInicialTraslado), condicionF3(consulta.valInicialTraslado), condicionF4(consulta.valInicialTraslado)],

        ],
    })

    // MARCA Y DEAMBULACION
    autoTable(doc, {
        startY: y2,
        margin: { left: 110, },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Marca/Deambulación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y2 = doc.lastAutoTable.finalY;

    autoTable(doc, {
        startY: y2,
        margin: { left: 110, },
        tableWidth: 50,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },
                {
                    content: "Si",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },
                {
                    content: "No",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },
                {
                    content: "",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },
                {
                    content: "Si",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },
                {
                    content: "No",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },

                },

            ]
        ],
        body: [
            ["Libre", returnBool(consulta.marchaDeambulacion.libre), returnBoolFALSE(consulta.marchaDeambulacion.libre), "Espásticas", returnBool(consulta.marchaDeambulacion.espasticas), returnBoolFALSE(consulta.marchaDeambulacion.espasticas),],
            ["Claudicante", returnBool(consulta.marchaDeambulacion.claudicante), returnBoolFALSE(consulta.marchaDeambulacion.claudicante), "Atáxica", returnBool(consulta.marchaDeambulacion.ataxica), returnBoolFALSE(consulta.marchaDeambulacion.ataxica),],
            ["Con Ayuda", returnBool(consulta.marchaDeambulacion.conAyuda), returnBoolFALSE(consulta.marchaDeambulacion.conAyuda), "Otros", returnBool(consulta.marchaDeambulacion.otros), returnBoolFALSE(consulta.marchaDeambulacion.otros),],
        ],
        columnStyles: {
            0: { cellWidth: 15 }, // enfermedad
            1: { cellWidth: 5, halign: "center" }, // si
            2: { cellWidth: 5, halign: "center" }, // no
            3: { cellWidth: 15 }, // enfermedad
            4: { cellWidth: 5, halign: "center" }, // si
            5: { cellWidth: 5, halign: "center" }, // no
        },
    })

    autoTable(doc, {
        startY: y2,
        margin: { left: 160, },
        tableWidth: 40,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    },
                },
            ]
        ],
        body: [
            [" "],
            [consulta.marchaDeambulacion.observaciones],
            [" "],
        ],

    })

    y = doc.lastAutoTable.finalY += 5;

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Escala del Dolor (" + consulta.escalaDolor + ")",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY;

    const img1 = await getBase64FromImage(imagen_1)

    doc.addImage(img1, 'PNG', 19, y, 180, 22)

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evaluación Muscular",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            ["La fuerza del paciente está graduada en una escala de 0 - 5"],
        ],
        columnStyles: {
            0: { fontSize: 9, halign: 'center', fontStyle: 'bold' },
        }
    })
    y = doc.lastAutoTable.finalY;

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },

        body: [
            ["Grado 5", "Fuerza muscular normal contra resistencia completa."],
            ["Grado 4", "La fuerza muscular está reducida pero la contracción muscular puede realizar un movimiento articular contra resistencia."],
            ["Grado 3", "La fuerza muscular está reducida tanto que el movimiento articular solo puede realizarse contra la gravedad, sin la resistencia del examinador. Por ejemplo, la articulación del codo puede moverse desde extensión completa hasta flexión completa, comenzando con el brazo suspendido al lado del cuerpo."],
            ["Grado 2", "Movimiento activo que no puede vencer la fuerza de gravedad. Por ejemplo, el codo puede flexionarse completamente solo cuando el brazo es mantenido en un plano horizontal."],
            ["Grado 1", "Esbozo de contracción muscular."],
            ["Grado 0", "Ausencia de contracción muscular."],
        ],
        columnStyles: {
            0: { cellWidth: 20, fontSize: 8, halign: 'center', fontStyle: 'bold' },
            1: { fontSize: 8, },
        }

    })

    y = doc.lastAutoTable.finalY += 5;

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evaluación 1",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Evaluación 2",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    y = doc.lastAutoTable.finalY
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Izquierda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Derecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Izquierda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Derecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                }
            ]
        ],
        body: [
            ["M. Sup.", consulta.evaluacionMuscular.miembroSuperior.evaluacion1Izquierda, consulta.evaluacionMuscular.miembroSuperior.evaluacion1Derecha, consulta.evaluacionMuscular.miembroSuperior.evaluacion2Izquierda, consulta.evaluacionMuscular.miembroSuperior.evaluacion2Derecha],
            ["M. Inf.", consulta.evaluacionMuscular.miembroInferior.evaluacion1Izquierda, consulta.evaluacionMuscular.miembroInferior.evaluacion1Derecha, consulta.evaluacionMuscular.miembroInferior.evaluacion2Izquierda, consulta.evaluacionMuscular.miembroInferior.evaluacion2Derecha],
            ["Tronco", consulta.evaluacionMuscular.tronco.evaluacion1Izquierda, consulta.evaluacionMuscular.tronco.evaluacion1Derecha, consulta.evaluacionMuscular.tronco.evaluacion2Izquierda, consulta.evaluacionMuscular.tronco.evaluacion2Derecha],
            ["Cuello", consulta.evaluacionMuscular.cuello.evaluacion1Izquierda, consulta.evaluacionMuscular.cuello.evaluacion1Derecha, consulta.evaluacionMuscular.cuello.evaluacion2Izquierda, consulta.evaluacionMuscular.cuello.evaluacion2Derecha],
        ],
        columnStyles: {
            0: { cellWidth: 20, cellPadding: 2, fontSize: 8 }, // enfermedad
            1: { halign: 'center' },
            2: { halign: 'center' },
            3: { halign: 'center' },
            4: { halign: 'center' },
        }
    })

    y = doc.lastAutoTable.finalY += 5

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evaluación Goniométrica",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })
    y = doc.lastAutoTable.finalY += 2.5

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evaluación 1",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Evaluación 2",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })
    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Izquierda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Derecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Izquierda",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Derecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                }
            ]
        ],
        body: [
            ["M. Sup.", consulta.evaluacionGoniometrica.miembroSuperior.evaluacion1Izquierda, consulta.evaluacionGoniometrica.miembroSuperior.evaluacion1Derecha, consulta.evaluacionGoniometrica.miembroSuperior.evaluacion2Izquierda, consulta.evaluacionGoniometrica.miembroSuperior.evaluacion2Derecha],
            ["M. Inf.", consulta.evaluacionGoniometrica.miembroInferior.evaluacion1Izquierda, consulta.evaluacionGoniometrica.miembroInferior.evaluacion1Derecha, consulta.evaluacionGoniometrica.miembroInferior.evaluacion2Izquierda, consulta.evaluacionGoniometrica.miembroInferior.evaluacion2Derecha],
            ["Tronco", consulta.evaluacionGoniometrica.tronco.evaluacion1Izquierda, consulta.evaluacionGoniometrica.tronco.evaluacion1Derecha, consulta.evaluacionGoniometrica.tronco.evaluacion2Izquierda, consulta.evaluacionGoniometrica.tronco.evaluacion2Derecha],
            ["Cuello", consulta.evaluacionGoniometrica.cuello.evaluacion1Izquierda, consulta.evaluacionGoniometrica.cuello.evaluacion1Derecha, consulta.evaluacionGoniometrica.cuello.evaluacion2Izquierda, consulta.evaluacionGoniometrica.cuello.evaluacion2Derecha],
        ],
        columnStyles: {
            0: { cellWidth: 20, cellPadding: 2, fontSize: 8 }, // enfermedad
            1: { halign: 'center' },
            2: { halign: 'center' },
            3: { halign: 'center' },
            4: { halign: 'center' },
        }
    })

    y = doc.lastAutoTable.finalY += 5

    const img2 = await getBase64FromImage(imagen_2)

    doc.addImage(img2, 'PNG', 19, y, 70, 70)

    autoTable(doc, {
        startY: y,
        margin: { left: 90, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Nota Clinica - Variación Iniciial",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },

            ]
        ],
        body: [
            [consulta.notasEvaluacionM.notaClinica],
        ],
    })
    y = doc.lastAutoTable.finalY += 5

    autoTable(doc, {
        startY: y,
        margin: { left: 90 },
        tableWidth: 52.5,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Subjetivo",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
            ]
        ],
        body: [
            [consulta.notasEvaluacionM.subjetivo1],
        ],
    })

    autoTable(doc, {
        startY: y,
        margin: { left: 147.5 },
        tableWidth: 52.5,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Subjetivo",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
            ]
        ],
        body: [
            [consulta.notasEvaluacionM.subjetivo2],
        ],
    })

    y = doc.lastAutoTable.finalY += 5

    autoTable(doc, {
        startY: y,
        margin: { left: 90, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Análisis",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },

            ]
        ],
        body: [
            [consulta.notasEvaluacionM.analisis],
        ],
    })

    y = doc.lastAutoTable.finalY += 5

    autoTable(doc, {
        startY: y,
        margin: { left: 90, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Plan de acción",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },

            ]
        ],
        body: [
            [consulta.notasEvaluacionM.planAccion],
        ],
    })

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40

    // PRUEBA DE ARCOS DE MOVILIDAD PARA MIEMBROS SUPERIORES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Prueba de Arcos de Movilidad para Miembros Superiores",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY += 1

    const img3 = await getBase64FromImage(imagen_3)
    const img4 = await getBase64FromImage(imagen_4)

    doc.addImage(img3, 'PNG', 15, y, 50, 50)
    doc.addImage(img4, 'PNG', 150, y, 50, 50)

    y = doc.lastAutoTable.finalY += 5

    // MOVIMIENTOS
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Movimientos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Hombro",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Hombro",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Flexión",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Extención",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "ABD.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "ADD.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],

        body: consulta.pruebaDeArcosHombro.lista.map((x) => [
            x.flexion,
            x.extension,
            x.abd,
            x.add,
        ]),

    })

    y = doc.lastAutoTable.finalY += 8

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaDeArcosHombro.observaciones]
        ]

    })


    // ROTACIO Y CODO
    y = doc.lastAutoTable.finalY += 5

    const img5 = await getBase64FromImage(imagen_5)
    const img6 = await getBase64FromImage(imagen_6)

    doc.addImage(img5, 'PNG', 15, y, 50, 30)
    doc.addImage(img6, 'PNG', 150, y, 50, 30)


    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Rotación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Codo",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Externa",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Interna",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Flexión",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Ext.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: consulta.pruebaDeArcosCodo.lista.map((x) => [
            x.externa,
            x.interna,
            x.flexion,
            x.ext,
        ]),

    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaDeArcosCodo.observaciones]
        ]

    })

    // ANTEBRAZO Y DESVIACION
    y = doc.lastAutoTable.finalY += 5

    const img7 = await getBase64FromImage(imagen_7)
    const img8 = await getBase64FromImage(imagen_8)

    doc.addImage(img7, 'PNG', 15, y, 50, 30)
    doc.addImage(img8, 'PNG', 150, y, 50, 30)


    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Antebrazo",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Desviación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Externa",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Interna",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Flexión",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Ext.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: consulta.pruebaDeAntebrazoMuneca.lista.map((x) => [
            x.externa,
            x.interna,
            x.flexion,
            x.ext,
        ]),

    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaDeAntebrazoMuneca.observaciones]
        ]

    })


    // PALMAR Y DORSAL
    y = doc.lastAutoTable.finalY += 5

    const img9 = await getBase64FromImage(imagen_9)

    doc.addImage(img9, 'PNG', 15, y, 50, 30)

    y = doc.lastAutoTable.finalY += 2.5

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Reflexión",
                    colSpan: 2,
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Dedos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "MCF",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "IFP",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "IFD",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "ABD",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                }
            ]
        ],
        body: [
            ["Palmar", "Dorsal", consulta.pruebaMovilidadPalmarDedos.reflexionDedo[0].dedo, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[0].mcf, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[0].ifp, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[0].ifd, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[0].abd],
            [consulta.pruebaMovilidadPalmarDedos.reflexion[0].palmar, consulta.pruebaMovilidadPalmarDedos.reflexion[0].dorsal, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[1].dedo, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[1].mcf, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[1].ifp, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[1].ifd, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[1].abd],
            [consulta.pruebaMovilidadPalmarDedos.reflexion[1].palmar, consulta.pruebaMovilidadPalmarDedos.reflexion[1].dorsal, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[2].dedo, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[2].mcf, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[2].ifp, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[2].ifd, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[2].abd],
            [consulta.pruebaMovilidadPalmarDedos.reflexion[2].palmar, consulta.pruebaMovilidadPalmarDedos.reflexion[2].dorsal, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[3].dedo, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[3].mcf, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[3].ifp, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[3].ifd, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[3].abd],
            [consulta.pruebaMovilidadPalmarDedos.reflexion[3].palmar, consulta.pruebaMovilidadPalmarDedos.reflexion[3].dorsal, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[4].dedo, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[4].mcf, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[4].ifp, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[4].ifd, consulta.pruebaMovilidadPalmarDedos.reflexionDedo[4].abd],
        ],
    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaMovilidadPalmarDedos.observaciones]
        ]

    })

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40

    // PRUEBA DE ARCOS DE MOVILIDAD PARA MIEMBROS INFERIORES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Prueba de Arcos de Movilidad para Miembros Inferiores",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY += 1

    const img10 = await getBase64FromImage(imagen_10)
    const img11 = await getBase64FromImage(imagen_11)

    doc.addImage(img10, 'PNG', 15, y, 50, 30)
    doc.addImage(img11, 'PNG', 150, y, 50, 30)

    y = doc.lastAutoTable.finalY += 2.5

    // MOVIMIENTOS
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Movimientos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Flexión Cadera c/rod. Ext.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: "Extención de Cadera",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                }
            ]
        ],
        body: consulta.pruebaDePiernas.lista.map((x) => [
            x.flexionCaderaRodillaExt,
            x.extensionCadera,
        ]),
    })


    y = doc.lastAutoTable.finalY += 4

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaDePiernas.observaciones]
        ]
    })

    // ANTEBRAZO Y DESVIACION
    y = doc.lastAutoTable.finalY += 5

    const img12 = await getBase64FromImage(imagen_12)
    const img13 = await getBase64FromImage(imagen_13)

    doc.addImage(img12, 'PNG', 15, y, 50, 30)
    doc.addImage(img13, 'PNG', 150, y, 50, 30)


    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Flexión Cadera",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9,
                        cellWidth: 38

                    }
                },
                {
                    content: "Rodilla",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9,
                        cellWidth: 38
                    }
                }
            ]
        ],
        columnStyles: {
            0: { cellWidth: 38 },
            1: { cellWidth: 38 },
        },

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "c/rod. Ext.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Flex.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Ext.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
            ]
        ],
        body: [
            ["1", "1", ""],
            ["2", "2", ""],
            ["3", "3", ""],
            ["4", "4", ""],
        ],
        columnStyles: {
            0: { cellWidth: 38 },
            1: { cellWidth: 19 },
            2: { cellWidth: 19 },
        },
    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaDeRodillas.observaciones]
        ]

    })

    // CADERA Y FLEXION
    y = doc.lastAutoTable.finalY += 5

    const img14 = await getBase64FromImage(imagen_14)
    const img15 = await getBase64FromImage(imagen_15)

    doc.addImage(img14, 'PNG', 15, y, 50, 30)
    doc.addImage(img15, 'PNG', 150, y, 50, 30)


    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Cadera",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Flexión",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "ABD.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "ADD.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "PLANT.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "DORS.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaMovPlantaPie.cadera[0].abd, consulta.pruebaMovPlantaPie.cadera[0].add, consulta.pruebaMovPlantaPie.flexion[0].plant, consulta.pruebaMovPlantaPie.flexion[0].dors],
            [consulta.pruebaMovPlantaPie.cadera[1].abd, consulta.pruebaMovPlantaPie.cadera[1].add, consulta.pruebaMovPlantaPie.flexion[1].plant, consulta.pruebaMovPlantaPie.flexion[1].dors],
            [consulta.pruebaMovPlantaPie.cadera[2].abd, consulta.pruebaMovPlantaPie.cadera[2].add, consulta.pruebaMovPlantaPie.flexion[2].plant, consulta.pruebaMovPlantaPie.flexion[2].dors],
            [consulta.pruebaMovPlantaPie.cadera[3].abd, consulta.pruebaMovPlantaPie.cadera[3].add, consulta.pruebaMovPlantaPie.flexion[3].plant, consulta.pruebaMovPlantaPie.flexion[3].dors],
        ],

    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaMovPlantaPie.observaciones]
        ]

    })

    // ROTACION Y TOBILLO
    y = doc.lastAutoTable.finalY += 5

    const img16 = await getBase64FromImage(imagen_16)
    const img17 = await getBase64FromImage(imagen_17)

    doc.addImage(img16, 'PNG', 15, y, 50, 30)
    doc.addImage(img17, 'PNG', 150, y, 50, 30)

    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Rotación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },
                {
                    content: "Tobillo",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 70, right: 70 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "EXT.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "INT.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "INV.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "EVE.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaMovPie.rotacion[0].ext, consulta.pruebaMovPie.rotacion[0].inte, consulta.pruebaMovPie.tobillo[0].inv, consulta.pruebaMovPie.tobillo[0].eve],
            [consulta.pruebaMovPie.rotacion[1].ext, consulta.pruebaMovPie.rotacion[1].inte, consulta.pruebaMovPie.tobillo[1].inv, consulta.pruebaMovPie.tobillo[1].eve],
            [consulta.pruebaMovPie.rotacion[2].ext, consulta.pruebaMovPie.rotacion[2].inte, consulta.pruebaMovPie.tobillo[2].inv, consulta.pruebaMovPie.tobillo[2].eve],
            [consulta.pruebaMovPie.rotacion[3].ext, consulta.pruebaMovPie.rotacion[3].inte, consulta.pruebaMovPie.tobillo[3].inv, consulta.pruebaMovPie.tobillo[3].eve],
        ],

    })

    y = doc.lastAutoTable.finalY += 5

    // OBSERVACIONES
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Observaciones:",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.pruebaMovPie.observaciones]
        ]

    })

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40

    // ANALISIS DE LA MARCHA
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Análisis de la Marcha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY



    const img18 = await getBase64FromImage(imagen_18)

    doc.addImage(img18, 'PNG', 15, y, 185, 70)

    let opciones1 = [
        ["Duda o vacila o múltiples intentos para comenzar", "0"],
        ["No vacilante", "1"]
    ]
    y = 110
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Inicio de la Marcha (Inmediatamente despues de decir 'camine')",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                },

            ]
        ],
        body: generarBody(opciones1, consulta.evaluacionDeLaMarcha),
        // body: [
        //     ["Duda o vacila o múltiples intentos para comenzar", "0"],
        //     ["No vacilante", "1"]
        // ],
        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },

    })

    y = doc.lastAutoTable.finalY

    let opciones2 = [
        ["El pie derecho no sobrepasa al izquierdo con el paso en la fase balanceo", "0"],
        ["El pie derecho sobrepasa al izquierdo con el paso", "1"],
        ["El pie derecho no se levanta completamente del suelo con el paso en la fase de balanceo", "0"],
        ["El pie derecho se levanta completamente", "1"],
        ["El pie izquierdo no sobrepasa al derecho con el paso en la fase balanceo", "0"],
        ["El pie izquierdo sobrepasa al derecho con el paso", "1"],
        ["El pie izquierdo no se levanta completamente del suelo con el paso en la fase de balanceo", "0"],
        ["El pie izquierdo se levanta completamente", "1"],

    ]
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Longitud y altura del paso",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones2, consulta.evaluacionDeLaMarcha),
        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },

    })

    y = doc.lastAutoTable.finalY

    let opciones3 = [
        ["La longitud del paso con el pie derecho e izquierdo es diferente (estimada)", "0"],
        ["Los pasos son iguales en longitud", "1"],
    ]

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Simetría del paso",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones3, consulta.evaluacionDeLaMarcha),

        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },
    })

    y = doc.lastAutoTable.finalY
    let opciones4 = [
        ["Para, o hay discontinuidad entre los pasos", "0"],
        ["Los pasos son continuos", "1"],
    ]
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Continuidad de los pasos",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones4, consulta.evaluacionDeLaMarcha),

        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },
    })

    y = doc.lastAutoTable.finalY
    let opciones5 = [
        ["Marcada desviación", "0"],
        ["Desviación moderada, media o utiliza ayuda", "1"],
        ["Derecho sin utilizar ayudas", "2"],
    ]
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Trayectoria (Estimada en relación a las baldosas del suelo de 30cm; se observa la desviación de un pie en 3 mts de distancia)",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones5, consulta.evaluacionDeLaMarcha),

        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },
    })

    y = doc.lastAutoTable.finalY
    let opciones6 = [
        ["Marcado balanceo o utliza ayudas", "0"],
        ["No balanceo pero hay reflexión de rodillas, espalda o extención hacia afuera de los brazos", "1"],
        ["No balanceo ni flexión, y tampoco utiliza ayudas", "2"],
    ]

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Tronco",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones6, consulta.evaluacionDeLaMarcha),
        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },
    })

    y = doc.lastAutoTable.finalY

    let opciones7 = [
        ["Talones separados", "0"],
        ["Talones casi se tocan mientras camina", "1"],
    ]
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Postura en la marcha",
                    colSpan: 2,
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

            ]
        ],
        body: generarBody(opciones7, consulta.evaluacionDeLaMarcha),
        columnStyles: {
            1: { cellWidth: 10, halign: 'center', fontStyle: 'bold' },
        },
    })

    y = doc.lastAutoTable.finalY

    let suma = consulta.evaluacionDeLaMarcha.reduce(
        (acumulador, objeto) => acumulador + objeto.valor,
        0
    );

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "TOTAL MARCHA",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

                {
                    content: suma + "/12",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 7,
                        cellWidth: 10
                    }
                },
            ]
        ],

    })
    y = doc.lastAutoTable.finalY



    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "TOTAL",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

                {
                    content: suma,
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 7,
                        cellWidth: 10
                    }
                },
            ]
        ],

    })
    y = doc.lastAutoTable.finalY


    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "TOTAL GENERAL",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 7
                    }
                },

                {
                    content: suma + "/28",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 7,
                        cellWidth: 10
                    }
                },
            ]
        ],

    })

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40

    // EVOLUCION EN LA POSTURA
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evolución en la Postura",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY + 2.5

    const img19 = await getBase64FromImage(imagen_19)

    doc.addImage(img19, 'PNG', 15, y, 70, 70)
    y = doc.lastAutoTable.finalY += 2.5

    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Vista Frontal",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY
    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: .5
        },
        head: [
            [
                {
                    content: "Alineación Corporal",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "L",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "M",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "S",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "Observaciones",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }

            ]
        ],
        body: [
            ["Inclinación lateral de la cabeza", gradoL(consulta.vistaFrontal.inclinacionLateralCabeza.grado), gradoM(consulta.vistaFrontal.inclinacionLateralCabeza.grado), gradoS(consulta.vistaFrontal.inclinacionLateralCabeza.grado), consulta.vistaFrontal.inclinacionLateralCabeza.observacion],
            ["Cabeza rotada", gradoL(consulta.vistaFrontal.cabezaRotada.grado), gradoM(consulta.vistaFrontal.cabezaRotada.grado), gradoS(consulta.vistaFrontal.cabezaRotada.grado), consulta.vistaFrontal.cabezaRotada.observacion],
            ["Asimetría maxilar", gradoL(consulta.vistaFrontal.asimetriaMaxilar.grado), gradoM(consulta.vistaFrontal.asimetriaMaxilar.grado), gradoS(consulta.vistaFrontal.asimetriaMaxilar.grado), consulta.vistaFrontal.asimetriaMaxilar.observacion],
            ["Clavículas asimétricas", gradoL(consulta.vistaFrontal.claviculasAsimetricas.grado), gradoM(consulta.vistaFrontal.claviculasAsimetricas.grado), gradoS(consulta.vistaFrontal.claviculasAsimetricas.grado), consulta.vistaFrontal.claviculasAsimetricas.observacion],
            ["Hombro caído", gradoL(consulta.vistaFrontal.hombroCaido.grado), gradoM(consulta.vistaFrontal.hombroCaido.grado), gradoS(consulta.vistaFrontal.hombroCaido.grado), consulta.vistaFrontal.hombroCaido.observacion],
            ["Hombro elevado", gradoL(consulta.vistaFrontal.hombroElevado.grado), gradoM(consulta.vistaFrontal.hombroElevado.grado), gradoS(consulta.vistaFrontal.hombroElevado.grado), consulta.vistaFrontal.hombroElevado.observacion],
            ["Cubito valgo", gradoL(consulta.vistaFrontal.cubitovalgo.grado), gradoM(consulta.vistaFrontal.cubitovalgo.grado), gradoS(consulta.vistaFrontal.cubitovalgo.grado), consulta.vistaFrontal.cubitovalgo.observacion],
            ["Cubito elevado", gradoL(consulta.vistaFrontal.cubitoVaro.grado), gradoM(consulta.vistaFrontal.cubitoVaro.grado), gradoS(consulta.vistaFrontal.cubitoVaro.grado), consulta.vistaFrontal.cubitoVaro.observacion],
            ["Rotación interna de cadera", gradoL(consulta.vistaFrontal.rotacionInternaCadera.grado), gradoM(consulta.vistaFrontal.rotacionInternaCadera.grado), gradoS(consulta.vistaFrontal.rotacionInternaCadera.grado), consulta.vistaFrontal.rotacionInternaCadera.observacion],
            ["Rotación externa de cadera", gradoL(consulta.vistaFrontal.rotacionExternaCadera.grado), gradoM(consulta.vistaFrontal.rotacionExternaCadera.grado), gradoS(consulta.vistaFrontal.rotacionExternaCadera.grado), consulta.vistaFrontal.rotacionExternaCadera.observacion],
            ["Genu varum", gradoL(consulta.vistaFrontal.genuVarum.grado), gradoM(consulta.vistaFrontal.genuVarum.grado), gradoS(consulta.vistaFrontal.genuVarum.grado), consulta.vistaFrontal.genuVarum.observacion],
            ["Genu valgum", gradoL(consulta.vistaFrontal.genuValgum.grado), gradoM(consulta.vistaFrontal.genuValgum.grado), gradoS(consulta.vistaFrontal.genuValgum.grado), consulta.vistaFrontal.genuValgum.observacion],
            ["Torsión tibial interna", gradoL(consulta.vistaFrontal.torsionTibialInterna.grado), gradoM(consulta.vistaFrontal.torsionTibialInterna.grado), gradoS(consulta.vistaFrontal.torsionTibialInterna.grado), consulta.vistaFrontal.torsionTibialInterna.observacion],
            ["Torsión tibial externa", gradoL(consulta.vistaFrontal.torsionTibialExterna.grado), gradoM(consulta.vistaFrontal.torsionTibialExterna.grado), gradoS(consulta.vistaFrontal.torsionTibialExterna.grado), consulta.vistaFrontal.torsionTibialExterna.observacion],
            ["Hailux valgus", gradoL(consulta.vistaFrontal.halluxValgus.grado), gradoM(consulta.vistaFrontal.halluxValgus.grado), gradoS(consulta.vistaFrontal.halluxValgus.grado), consulta.vistaFrontal.halluxValgus.observacion],
            ["Dedos en garra", gradoL(consulta.vistaFrontal.dedosEnGarra.grado), gradoM(consulta.vistaFrontal.dedosEnGarra.grado), gradoS(consulta.vistaFrontal.dedosEnGarra.grado), consulta.vistaFrontal.dedosEnGarra.observacion],
            ["Dedos en martillo", gradoL(consulta.vistaFrontal.dedosEnMartillo.grado), gradoM(consulta.vistaFrontal.dedosEnMartillo.grado), gradoS(consulta.vistaFrontal.dedosEnMartillo.grado), consulta.vistaFrontal.dedosEnMartillo.observacion],
        ],
        columnStyles: {
            0: { cellWidth: 35, halign: 'left', fontStyle: 'bold' },
            1: { cellWidth: 7, halign: 'center', },
            2: { cellWidth: 7, halign: 'center', },
            3: { cellWidth: 7, halign: 'center', },
        },
    })

    y = doc.lastAutoTable.finalY + 2.5

    const img20 = await getBase64FromImage(imagen_20)

    doc.addImage(img20, 'PNG', 15, y, 70, 70)
    y = doc.lastAutoTable.finalY += 2.5

    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Vista Lateral",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: .5
        },
        head: [
            [
                {
                    content: "Alineación Corporal",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "L",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "M",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "S",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "Observaciones",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }

            ]
        ],
        body: [
            ["Desplazamiento anterior del cuerpo",  gradoL(consulta.vistaLateral.desplazamientoAnteriorCuerpo.grado), gradoM(consulta.vistaLateral.desplazamientoAnteriorCuerpo.grado), gradoS(consulta.vistaLateral.desplazamientoAnteriorCuerpo.grado), consulta.vistaLateral.desplazamientoAnteriorCuerpo.observacion],
            ["Desplazamiento posteior del cuerpo", gradoL(consulta.vistaLateral.desplazamientoPosteriorCuerpo.grado), gradoM(consulta.vistaLateral.desplazamientoPosteriorCuerpo.grado), gradoS(consulta.vistaLateral.desplazamientoPosteriorCuerpo.grado), consulta.vistaLateral.desplazamientoPosteriorCuerpo.observacion],
            ["Cabeza adelantada", gradoL(consulta.vistaLateral.cabezaAdelantada.grado), gradoM(consulta.vistaLateral.cabezaAdelantada.grado), gradoS(consulta.vistaLateral.cabezaAdelantada.grado), consulta.vistaLateral.cabezaAdelantada.observacion],
            ["Vertebras torácicas: Cifosis", gradoL(consulta.vistaLateral.vertebrasToracicasCifosis.grado), gradoM(consulta.vistaLateral.vertebrasToracicasCifosis.grado), gradoS(consulta.vistaLateral.vertebrasToracicasCifosis.grado), consulta.vistaLateral.vertebrasToracicasCifosis.observacion],
            ["Vertebras torácicas: Pectus Excavatum", gradoL(consulta.vistaLateral.vertebrasToracicasPectusExcavatum.grado), gradoM(consulta.vistaLateral.vertebrasToracicasPectusExcavatum.grado), gradoS(consulta.vistaLateral.vertebrasToracicasPectusExcavatum.grado), consulta.vistaLateral.vertebrasToracicasPectusExcavatum.observacion],
            ["Pecho en tonel", gradoL(consulta.vistaLateral.pechoEnTonel.grado), gradoM(consulta.vistaLateral.pechoEnTonel.grado), gradoS(consulta.vistaLateral.pechoEnTonel.grado), consulta.vistaLateral.pechoEnTonel.observacion],
            ["Pectus carinatum", gradoL(consulta.vistaLateral.pectusCarinatum.grado), gradoM(consulta.vistaLateral.pectusCarinatum.grado), gradoS(consulta.vistaLateral.pectusCarinatum.grado), consulta.vistaLateral.pectusCarinatum.observacion],
            ["Columna: Lordosis", gradoL(consulta.vistaLateral.columnaLordosis.grado), gradoM(consulta.vistaLateral.columnaLordosis.grado), gradoS(consulta.vistaLateral.columnaLordosis.grado), consulta.vistaLateral.columnaLordosis.observacion],
            ["Espalda cifotica (Columna)",  gradoL(consulta.vistaLateral.espaldaCifotica.grado), gradoM(consulta.vistaLateral.espaldaCifotica.grado), gradoS(consulta.vistaLateral.espaldaCifotica.grado), consulta.vistaLateral.espaldaCifotica.observacion],
            ["Espalda plana (Columna)", gradoL(consulta.vistaLateral.espaldaPlanaColumna.grado), gradoM(consulta.vistaLateral.espaldaPlanaColumna.grado), gradoS(consulta.vistaLateral.espaldaPlanaColumna.grado), consulta.vistaLateral.espaldaPlanaColumna.observacion],
            ["Inclinación ant. de pelvis y cadera",  gradoL(consulta.vistaLateral.inclinacionAnteriorPelvisCadera.grado), gradoM(consulta.vistaLateral.inclinacionAnteriorPelvisCadera.grado), gradoS(consulta.vistaLateral.inclinacionAnteriorPelvisCadera.grado), consulta.vistaLateral.inclinacionAnteriorPelvisCadera.observacion],
            ["Inclinación post. de pelvis y cadera",  gradoL(consulta.vistaLateral.inclinacionPosteriorPelvisCadera.grado), gradoM(consulta.vistaLateral.inclinacionPosteriorPelvisCadera.grado), gradoS(consulta.vistaLateral.inclinacionPosteriorPelvisCadera.grado), consulta.vistaLateral.inclinacionPosteriorPelvisCadera.observacion],
            ["Genu recuvatum", gradoL(consulta.vistaLateral.genuRecurvatum.grado), gradoM(consulta.vistaLateral.genuRecurvatum.grado), gradoS(consulta.vistaLateral.genuRecurvatum.grado), consulta.vistaLateral.genuRecurvatum.observacion],
            ["Rodillas flexionadas", gradoL(consulta.vistaLateral.rodillasFlexionadas.grado), gradoM(consulta.vistaLateral.rodillasFlexionadas.grado), gradoS(consulta.vistaLateral.rodillasFlexionadas.grado), consulta.vistaLateral.rodillasFlexionadas.observacion],
        ],
        columnStyles: {
            0: { cellWidth: 40, halign: 'left', fontStyle: 'bold' },
            1: { cellWidth: 7, halign: 'center', },
            2: { cellWidth: 7, halign: 'center', },
            3: { cellWidth: 7, halign: 'center', },
        },
    })

    // VISTA POSTERIOR
    y = doc.lastAutoTable.finalY + 10

    const img21 = await getBase64FromImage(imagen_21)

    doc.addImage(img21, 'PNG', 15, y, 70, 70)
    y = doc.lastAutoTable.finalY += 10

    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Vista Posterior",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })
    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 85, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: .5
        },
        head: [
            [
                {
                    content: "Alineación Corporal",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "L",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "M",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "S",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },

                {
                    content: "Observaciones",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                }

            ]
        ],
        body: [
            ["Cabeza inclinada",  gradoL(consulta.vistaPosterior.cabezaInclinada.grado), gradoM(consulta.vistaPosterior.cabezaInclinada.grado), gradoS(consulta.vistaPosterior.cabezaInclinada.grado), consulta.vistaPosterior.cabezaInclinada.observacion],
            ["Cabeza rotada",   gradoL(consulta.vistaPosterior.cabezaRotadaPosterior.grado), gradoM(consulta.vistaPosterior.cabezaRotadaPosterior.grado), gradoS(consulta.vistaPosterior.cabezaRotadaPosterior.grado), consulta.vistaPosterior.cabezaRotadaPosterior.observacion],
            ["Hombro caído",   gradoL(consulta.vistaPosterior.hombroCaidoPosterior.grado), gradoM(consulta.vistaPosterior.hombroCaidoPosterior.grado), gradoS(consulta.vistaPosterior.hombroCaidoPosterior.grado), consulta.vistaPosterior.hombroCaidoPosterior.observacion],
            ["Hombro elevado",  gradoL(consulta.vistaPosterior.hombroElevadoPosterior.grado), gradoM(consulta.vistaPosterior.hombroElevadoPosterior.grado), gradoS(consulta.vistaPosterior.hombroElevadoPosterior.grado), consulta.vistaPosterior.hombroElevadoPosterior.observacion],
            ["Espalda plana",   gradoL(consulta.vistaPosterior.espaldaPlanaPosterior.grado), gradoM(consulta.vistaPosterior.espaldaPlanaPosterior.grado), gradoS(consulta.vistaPosterior.espaldaPlanaPosterior.grado), consulta.vistaPosterior.espaldaPlanaPosterior.observacion],
            ["Abducción de escapulas",   gradoL(consulta.vistaPosterior.abduccionEscapulas.grado), gradoM(consulta.vistaPosterior.abduccionEscapulas.grado), gradoS(consulta.vistaPosterior.abduccionEscapulas.grado), consulta.vistaPosterior.abduccionEscapulas.observacion],
            ["Aducción de escapulas",  gradoL(consulta.vistaPosterior.aduccionEscapulas.grado), gradoM(consulta.vistaPosterior.aduccionEscapulas.grado), gradoS(consulta.vistaPosterior.aduccionEscapulas.grado), consulta.vistaPosterior.aduccionEscapulas.observacion],
            ["Escapulas aladas",  gradoL(consulta.vistaPosterior.escapulasAladas.grado), gradoM(consulta.vistaPosterior.escapulasAladas.grado), gradoS(consulta.vistaPosterior.escapulasAladas.grado), consulta.vistaPosterior.escapulasAladas.observacion],
            ["Curvatura lateral de la columna",   gradoL(consulta.vistaPosterior.curvaturaLateralColumna.grado), gradoM(consulta.vistaPosterior.curvaturaLateralColumna.grado), gradoS(consulta.vistaPosterior.curvaturaLateralColumna.grado), consulta.vistaPosterior.curvaturaLateralColumna.observacion],
            ["Rotación interna de cadera (Tronco)",   gradoL(consulta.vistaPosterior.rotacionInternaCaderaPosterior.grado), gradoM(consulta.vistaPosterior.rotacionInternaCaderaPosterior.grado), gradoS(consulta.vistaPosterior.rotacionInternaCaderaPosterior.grado), consulta.vistaPosterior.rotacionInternaCaderaPosterior.observacion],
            ["Rotación externa de cadera",  gradoL(consulta.vistaPosterior.rotacionExternaCaderaPosterior.grado), gradoM(consulta.vistaPosterior.rotacionExternaCaderaPosterior.grado), gradoS(consulta.vistaPosterior.rotacionExternaCaderaPosterior.grado), consulta.vistaPosterior.rotacionExternaCaderaPosterior.observacion],
            ["Inclinación lateral de la pelvis",  gradoL(consulta.vistaPosterior.inclinacionLateralPelvis.grado), gradoM(consulta.vistaPosterior.inclinacionLateralPelvis.grado), gradoS(consulta.vistaPosterior.inclinacionLateralPelvis.grado), consulta.vistaPosterior.inclinacionLateralPelvis.observacion],
            ["Rotación pélvica",  gradoL(consulta.vistaPosterior.rotacionPelvica.grado), gradoM(consulta.vistaPosterior.rotacionPelvica.grado), gradoS(consulta.vistaPosterior.rotacionPelvica.grado), consulta.vistaPosterior.rotacionPelvica.observacion],
            ["Cadera Abducida",  gradoL(consulta.vistaPosterior.caderaAbducida.grado), gradoM(consulta.vistaPosterior.caderaAbducida.grado), gradoS(consulta.vistaPosterior.caderaAbducida.grado), consulta.vistaPosterior.caderaAbducida.observacion],
            ["Pie pronado",  gradoL(consulta.vistaPosterior.piePronado.grado), gradoM(consulta.vistaPosterior.piePronado.grado), gradoS(consulta.vistaPosterior.piePronado.grado), consulta.vistaPosterior.piePronado.observacion],
            ["Pie supinado",   gradoL(consulta.vistaPosterior.pieSupinado.grado), gradoM(consulta.vistaPosterior.pieSupinado.grado), gradoS(consulta.vistaPosterior.pieSupinado.grado), consulta.vistaPosterior.pieSupinado.observacion],
            ["Pie plano",  gradoL(consulta.vistaPosterior.piePlano.grado), gradoM(consulta.vistaPosterior.piePlano.grado), gradoS(consulta.vistaPosterior.piePlano.grado), consulta.vistaPosterior.piePlano.observacion],
            ["Pie cavo",  gradoL(consulta.vistaPosterior.pieCavo.grado), gradoM(consulta.vistaPosterior.pieCavo.grado), gradoS(consulta.vistaPosterior.pieCavo.grado), consulta.vistaPosterior.pieCavo.observacion],
        ],
        columnStyles: {
            0: { cellWidth: 40, halign: 'left', fontStyle: 'bold' },
            1: { cellWidth: 7, halign: 'center', },
            2: { cellWidth: 7, halign: 'center', },
            3: { cellWidth: 7, halign: 'center', },
        },
    })

    doc.addPage()

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('HOJA CLÍNICA FISIOTERAPIA', pageWidth / 2, 25, { align: 'center' })

    y = 40
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Formulario de valoración de la batería breve de valoración funcional",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

    })

    y = doc.lastAutoTable.finalY + 2.5
    // EVOLUCION EN LA POSTURA
    autoTable(doc, {
        startY: y,
        margin: { left: 15 },
        tableWidth: 90,
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 7,
            cellPadding: 0
        },
        head: [
            [
                {
                    content: "Pruebas de equilibrio",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            ["El sujeto debe ser capaz de ponerse de pie, sin ayuda de bastones o andadores"],
            [""],
            ["A. Posición con los pies juntos. "],
            ["  (1) Se sostuvo durante 10 segundos. "],
            ["  (0) No se sostuvo durante 10 segundos. "],
            ["  (0) No lo intento _____. "],
            [""],
            ["En caso de obtener cero puntos, termine la prueba de equilibrio."],
            [""],
            ["B. Posición de semitándem. "],
            ["  (1) Se sostuvo durante 10 segundos. "],
            ["  (0) No se sostuvo durante 10 segundos. "],
            ["  (0) No lo intento _____. "],
            [""],
            ["Número de segundos con equilibrio si es inferior a los 10 segundos."],
            [""],
            ["C. Posición en tándem completo. "],
            ["  (2) Se sostuvo durante 10 segundos. "],
            ["  (1) No se sostuvo durante 3 a 9 segundos. "],
            ["  (0) No se sostuvo durante al menos 3 segundos"],
            ["  (0) No lo intento _____. "],
        ],


    })

    autoTable(doc, {
        startY: y,
        margin: { left: 110, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 7,
            cellPadding: 0
        },
        head: [
            [
                {
                    content: "Pruebas de equilibrio",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            ["Número de segundos con equilibrio si es inferior a 10 segundos: _______"],
            [""],
            ["D. Puntuación total de equilibrió ____ (uma de puntos)"],
            [""],
            ["Si NO se realizó la prueba."],
            [""],
            ["Indique el motivo que mejor refleja por qué el sujeto no realizo las pruebas. Anote el número en el espacio en blanco pertinente detrás de la prueba NO REALIZADA."],
            [""],
            [" - Lo intentó pero no fue capaz ... 1"],
            [" - El sujeto no pudo ponerse de pie sin ayuda ... 2"],
            [" - No lo intentó, usted lo notaba inseguro ... 3"],
            [" - No lo intentó el sujeto se sentia inseguro ... 4"],
            [" - El sujeto no entendió las instrucciones ... 5"],
            [" - Otro motivo (especifiquelo) ... 6"],
            [" - El sujeto rechazó la prueba ... 7"],
        ],


    })
    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 110, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 0
        },
        head: [
            [
                {
                    content: "Comentarios",
                    styles: {
                        halign: "left",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.valoracionFuncional.comentarios],
        ],
    })

    y = doc.lastAutoTable.finalY += 10
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Plan Analítico de Atención Integral de Terapia Física",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
    })

    y = doc.lastAutoTable.finalY += 2.5
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Objetivos",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Hipotesis",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Estructura Corp.",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Función Corporal",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Actividad",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Participación",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
            ]
        ],
        body: [
            [consulta.valoracionFuncional.obejtivos, consulta.valoracionFuncional.hipotesis, consulta.valoracionFuncional.estructuraCorp, consulta.valoracionFuncional.funcionCorp, consulta.valoracionFuncional.actividad, consulta.valoracionFuncional.participacion]
        ],
        0: { cellWidth: 30.8, halign: 'left' },
        1: { cellWidth: 30.8, halign: 'left' },
        2: { cellWidth: 30.8, halign: 'left' },
        3: { cellWidth: 30.8, halign: 'left' },
        4: { cellWidth: 30.8, halign: 'left' },
        5: { cellWidth: 30.8, halign: 'left' },
    })

    y = doc.lastAutoTable.finalY

    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 16 },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 6,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Diagnóstico",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
                {
                    content: "Plan",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 6
                    }
                },
            ]
        ],
        body: [
            [consulta.valoracionFuncional.diagnostico, consulta.valoracionFuncional.plan]
        ],
        columnStyles: {
            0: { cellWidth: 92.5, halign: 'left' },
            1: { cellWidth: 92.5, halign: 'left' },
        }
    })

    y = doc.lastAutoTable.finalY += 2.5

    // autoTable(doc, {
    //     startY: y,
    //     margin: { left: 15, right: 16 },
    //     headStyles: {
    //         fillColor: [230, 230, 230],
    //         textColor: [0, 0, 0]
    //     },
    //     styles: {
    //         fontSize: 6,
    //         cellPadding: 5
    //     },
    //     head: [
    //         [
    //             {
    //                 content: "Diagnóstico",
    //                 styles: {
    //                     halign: "center",
    //                     fontStyle: "bold",
    //                     fontSize: 6
    //                 }
    //             },
    //             {
    //                 content: "Plan",
    //                 styles: {
    //                     halign: "center",
    //                     fontStyle: "bold",
    //                     fontSize: 6
    //                 }
    //             },
    //         ]
    //     ],
    //     body: [
    //         ["DX. Fisioterapeutico", "________________________________"],
    //         ["Código CIF", "Fisioterapeuta"]
    //     ],
    //     columnStyles: {
    //         0: { cellWidth: 92.5, halign: 'center' },
    //         1: { cellWidth: 92.5, halign: 'center' },
    //     }
    // })

    
  const lineaY = y 
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)

  doc.line(pageWidth / 2 - 30, lineaY + 25, pageWidth / 2 + 30, lineaY + 25)
  doc.text(formatMayusculas(medico.nombre + ' ' + medico.apellidoPaterno + ' ' + medico.apellidoMaterno), pageWidth / 2, lineaY + 30, { align: 'center' })
  doc.text('Fisioterapeuta', pageWidth / 2, lineaY + 35, { align: 'center' })

    // console.log(pageWidth)

    const base64 = doc.output('datauristring')
    return base64
}
export { generarHojaFisioterapia }